import type { RequestParams } from '../requests/http-client';
import { HttpClient } from '../requests/http-client';
import type { BaseErrorResponse, Cs2TransportClassVM } from './data-contracts';


export default function useTransportClass() {
  class TransportClass<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Transport Class
     * @name TransportClassControllerGetTransportClasses
     * @summary Returns a list of transport classes
     * @request GET:/cs2/transport-class
     * @secure
     * @response `200` `(Cs2TransportClassVM)[]`
     * @response `400` `BaseErrorResponse`
     */
    transportClassControllerGetTransportClasses = (
      query?: {
        /** @example 1 */
        channelId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<Cs2TransportClassVM[], BaseErrorResponse>({
        path: '/cs2/transport-class',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new TransportClass();
}
